import { FC, ReactElement, ReactNode } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import styles from './auth-container.module.scss';

import { openCookieSettings } from 'lib/consent';
import { SizeFormat } from 'types/ui.interface';
import { Logo } from 'views/components/UI/Logo';

interface IAuthContainerProps {
  children: ReactNode;
  maxWidth?: SizeFormat;
}

const AuthContainer: FC<IAuthContainerProps> = (props): ReactElement => {
  const { children, maxWidth = '352px' } = props;
  const intl = useIntl();

  const objStyles = {
    maxWidth,
  };

  return (
    <div className={styles['page-wrapper']}>
      <div className={styles.content}>
        <div className={styles.logo}>
          <Logo width={120} />
        </div>
        <div style={objStyles} className={styles['card-container']}>
          {children}
        </div>
      </div>
      <div className={styles.footer}>
        <a
          href="https://www.skiloope.com/terms-of-use"
          target="_blank"
          rel="noopener noreferrer"
          aria-label={intl.formatMessage({ id: 'auth-footer.terms' })}
        >
          <FormattedMessage id="auth-footer.terms" />
        </a>
        <a
          href="https://www.skiloope.com/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          aria-label={intl.formatMessage({ id: 'auth-footer.privacy' })}
        >
          <FormattedMessage id="auth-footer.privacy" />
        </a>
        <button
          type="button"
          onClick={openCookieSettings}
          aria-label={intl.formatMessage({ id: 'auth-footer.cookie-settings' })}
        >
          <FormattedMessage id="auth-footer.cookie-settings" />
        </button>
      </div>
    </div>
  );
};

export { AuthContainer };
